import { getSelectionChain } from "../components/MainComponents/Catalogues/utils/GetSelectionChain";

/** Separador con el que se arma la etiqueta de una ruta jerarquica. */
export const CATALOGUE_LABEL_SEPARATOR = " > ";

/**
 * Traduce la ruta de un catalogo a su etiqueta legible.
 *
 * Se guarda la etiqueta junto a la ruta —no solo la ruta— para que las vistas
 * de solo lectura no tengan que consultar el catalogo cada vez que se pintan,
 * y para que el expediente conserve como se llamaba la opcion al momento de
 * elegirla: si despues renombran la rama, el registro historico no cambia.
 */
export const resolveCatalogueLabel = async ({
  code,
  isOwn = false,
  path,
  separator = CATALOGUE_LABEL_SEPARATOR,
}) => {
  if (!code || !path) return "";
  try {
    const label = await getSelectionChain({
      catalogue: code,
      isOwn,
      value: path,
      separator,
    });
    return label || "";
  } catch (error) {
    console.error(error);
    return "";
  }
};
